import { axios } from '@Root/API'

export const remove = roleId => {
	return axios.delete(`roles/${roleId}/delete`)
}
